export default __webpack_public_path__ + "static/media/johnstone.cba6b5fe.jpg";